// @flow

import React from "react";
import { localize } from "redux-i18n";

import actionCreators from "@modules/service/actionCreator";
import { Row, Col, Button, Icons, SchemaTable } from "@components";
import type { AbsenceMonitoringTask } from "@modules/service/reducer/absence-monitoring/types";

type OwnProps = $Exact<{
  data: Array<AbsenceMonitoringTask>,
  schema: Object,
  onChange?: Function,
  onSubmit?: Function,
  editing?: boolean,
  disabled?: boolean,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class AbsenceMonitoringTasksForm extends React.Component<Props> {
  get defaultTask() {
    return [
      {
        id: new Date().getTime(),
        name: null,
        instruction: null,
        kpiTarget: null,
      },
    ];
  }

  get data() {
    return this.props.data || [];
  }

  get schema() {
    return this.props.schema;
  }

  get uiSchema() {
    return {
      "ui:order": ["name", "instruction", "kpiTarget"],
      name: {
        "ui:title": "Task Name",
        "ui:widget": "text",
        "ui:options": {
          required: true,
          minWidth: "25%",
          editable: true,
          disabled: false,
        },
      },
      instruction: {
        "ui:title": "Instruction to Manager",
        "ui:widget": "text",
        "ui:options": {
          required: true,
          minWidth: "50%",
          editable: true,
          disabled: false,
        },
      },
      kpiTarget: {
        "ui:title": "KPI Target",
        "ui:widget": "number",
        "ui:options": {
          required: true,
          minWidth: "25%",
          editable: true,
          disabled: false,
        },
      },
    };
  }

  handleAdd = () => {
    this.props.onChange && this.props.onChange([...this.data, ...this.defaultTask]);
  };

  handleChange = (data: Array<Object>) => {
    this.props.onChange && this.props.onChange(data);
  };

  render() {
    return (
      <div>
        {this.props.disabled ? null : (
          <Row>
            <Col sm="12" className="d-flex justify-content-end">
              <Button className="link record-table__add-button" onClick={this.handleAdd}>
                <span className="material-icons font-size-26 mr-1">add</span>
                {this.props.t("ADD_NEW_TASK")}
              </Button>
              <div />
            </Col>
          </Row>
        )}
        <Row>
          <Col sm="12">
            {this.schema && this.uiSchema ? (
              <SchemaTable
                tableData={this.data}
                schema={this.schema}
                uiSchema={this.uiSchema}
                disabled={!!this.props.disabled}
                onChange={this.handleChange}
                allowDeletes
              />
            ) : null}
          </Col>
        </Row>
      </div>
    );
  }
}

export default localize()(AbsenceMonitoringTasksForm);
